module.exports = __webpack_public_path__ + "img/o365_onedrive.238ed577.svg";